import React, { useCallback } from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import { FormattedMessage } from 'react-intl'
import Ask from '../../../../components/ask'
import GroupProducts from '../../../../fragments/item/group'
import Checkbox from '../../../../components/checkbox'
import { Iconfont } from '../../../../../../components/icon/iconfont'
import deeplink from '../../../../../../../utils/deeplink'
import FreeShipingTip, {FreeShippingLineTip} from "../freeShippingTip";
import Cache from "../../../../../../../utils/cache";
import {getSensorsUrl} from "../../../../../../utils/sensor";
import {useSelector} from "react-redux";
import {useHistory} from "react-router-dom";

const ProductGroup = props => {
    useStyles(classes)

    const { caseItem, onSelect, selectedItems, editing, itemDeleteHandle, itemChangeQtyHandle, addToWishList, itemChangeItemHandle, groupSort } = props
    const { shoppingCartProducts, combinedDisplay } = caseItem

    return <div className={classes.ProductGroup}>
        {
            combinedDisplay && <div className={classes.Hd}>
                <div className={classes.TitleArea}>
                    {
                        combinedDisplay.icon && <img className={classes.Icon} src={combinedDisplay.icon} />
                    }
                    <span className={classes.Title} dangerouslySetInnerHTML={{ __html: combinedDisplay.title }} />
                    {
                        combinedDisplay.description && <Ask content={combinedDisplay.description} />
                    }
                </div>
                {
                    combinedDisplay.deepLink && <a href={deeplink(combinedDisplay?.deepLink, "msite")} className={classes.DeepLink}><Iconfont>&#xe690;</Iconfont></a>
                }
            </div>
        }

        <div className={classes.Bd}>
            <GroupProducts groupSort={groupSort} itemChangeItemHandle={itemChangeItemHandle} addToWishList={addToWishList} itemChangeQtyHandle={itemChangeQtyHandle} itemDeleteHandle={itemDeleteHandle} editing={editing} selectedItems={selectedItems} onSelect={onSelect} items={shoppingCartProducts} />
        </div>
    </div>
}

export const InvalidGroup = props => {
    useStyles(classes)
    const { soldoutRegionalCase, removeItemsHandle, addToWishList } = props
    const { shoppingCartProducts } = soldoutRegionalCase || {}

    const moveAllHandle = () => {
        const itemIds = shoppingCartProducts?.map(s => s.id)?.join(',')
        removeItemsHandle(itemIds)
    }

    return <div className={classes.ProductGroup}>
        <div className={`${classes.Hd} ${classes.SoldOut}`}>
            <span className={classes.Title}>
                <FormattedMessage id="out_of_stock" defaultMessage="Out of stock" />
            </span>
            <span className={classes.MoveAll} onClick={moveAllHandle}>
                <FormattedMessage id="move_all" defaultMessage="Move All" />
            </span>
        </div>

        <div className={classes.Bd}>
            <GroupProducts soldout items={shoppingCartProducts} addToWishList={addToWishList} />
        </div>
    </div>
}

const RegionalCase = props => {
    useStyles(classes)
    const {
        regionalCase,
        sort,
        isMultiGroup,
        onSelect,
        onGroupSelect,
        editing,
        selectedItems,
        itemDeleteHandle,
        itemChangeQtyHandle,
        addToWishList,
        itemChangeItemHandle,
    } = props
    const { caseItems, title } = regionalCase
    const global = useSelector(state => state.global)
    const pageCart = useSelector(state => state.pageCart)
    const { cart } = pageCart
    const history = useHistory()

    let isGroupSelected

    if (editing) {
        isGroupSelected = !caseItems?.map(caseItem => {
            const { shoppingCartProducts } = caseItem
            return !shoppingCartProducts?.some(i => !selectedItems?.some(j => j.id === i.id))
        })?.some(i => !i)
    } else {
        isGroupSelected = !caseItems?.map(caseItem => {
            const { shoppingCartProducts } = caseItem
            return !shoppingCartProducts?.some(i => !i.selected)
        })?.some(i => !i)
    }

    // console.log("@regionalCase",regionalCase)
    return <div>

        {
            isMultiGroup && <div className={classes.MultiHead}>
            <div>
                <Checkbox selected={isGroupSelected} onClick={e => onGroupSelect(regionalCase, !isGroupSelected)} />
                <span className={classes.Title}>{title}</span>
            </div>
            </div>
        }
        {
            (isMultiGroup && regionalCase&&regionalCase.shippingMsg && regionalCase.shippingMsg.msg && !regionalCase.shippingMsg.shoppingCartHidden && !regionalCase.shippingMsg.freeMsg ) &&
            <FreeShipingTip cart={cart} msg={regionalCase.shippingMsg.msg} isBW={global?.config?.shortName === "bellewholesale"} clickFunc={
                regionalCase.shippingMsg?.deepLink ? (e, sensors) => {
                    Cache.remove("__progress_coupon_id")
                    history.push(getSensorsUrl(`/cart/collect-products?type=${regionalCase.shipsFrom==='US'?3:0}`, sensors))
                } : undefined
            }/>
        }
        {
            isMultiGroup && regionalCase?.shippingMsg?.msg && regionalCase.shippingMsg.freeMsg &&  <FreeShippingLineTip underMsg={regionalCase?.shippingMsg?.msg}/>
        }

        <div className={`${classes.ProductGroups} ${isMultiGroup ? classes.MultiGroup : ''}`}>
            {
                caseItems?.map((caseItem, index) => <ProductGroup groupSort={sort} itemChangeItemHandle={itemChangeItemHandle} addToWishList={addToWishList} itemChangeQtyHandle={itemChangeQtyHandle} itemDeleteHandle={itemDeleteHandle} selectedItems={selectedItems} editing={editing} onSelect={onSelect} caseItem={caseItem} key={index} />)
            }
        </div>
    </div>
}

export default props => {
    useStyles(classes)

    const {
        regionalCases,
        groupSelectHandle,
        itemSelectHandle,
        editing,
        selectedItems,
        itemDeleteHandle,
        itemChangeQtyHandle,
        addToWishList,
        itemChangeItemHandle,
    } = props
    const isMultiGroup = regionalCases?.length > 1

    return <div className={classes.RegionalCases}>
        {
            regionalCases?.map((regionalCase, index) => <RegionalCase itemChangeItemHandle={itemChangeItemHandle} addToWishList={addToWishList} itemChangeQtyHandle={itemChangeQtyHandle} itemDeleteHandle={itemDeleteHandle} selectedItems={selectedItems} editing={editing} onGroupSelect={groupSelectHandle} onSelect={itemSelectHandle} isMultiGroup={isMultiGroup} sort={index + 1} regionalCase={regionalCase} key={index} />)
        }
    </div>
}